export const getNormalizedNumberFromString = str =>
  (typeof str === 'string' && str?.trim() === '') || str === null ? null : Number(str) ?? null
